"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSearchMap;
exports.mergeSearchParamsWithCurrentCookie = mergeSearchParamsWithCurrentCookie;

var _cookies = _interopRequireDefault(require("./lib/cookies"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSearchMap() {
  return parseSearchString(getSearchStringFromURL());
}
/**
 * Parses a string of query params separated by "&" and returns a whitelisted object of key/values
 * @param {string} query string (can be fetched by #getSearchStringFromURL)
 * @return {Object}
 */


function parseSearchString(queryString = '') {
  const queryHash = {};
  const pairs = queryString.split('&');
  pairs.forEach(pair => {
    const [encodedKey, encodedValue] = pair.split('=');
    const key = decodeURIComponent(encodedKey);
    const value = decodeURIComponent(encodedValue);

    if (value && _constants.QUERY_SEARCH_PARAMS_WHITELIST.includes(key)) {
      queryHash[key] = value;
    }
  });
  return queryHash;
}
/**
 * Returns the current search value from the URL and strips out the "?"
 * @return {String}
 */


function getSearchStringFromURL() {
  if (!window) return;
  if (!window.location.search) return; // remove ? from string

  return window.location.search.substr(1);
}
/**
 * Merges an object with the current value of the search params cookie
 * @param {Object} A map of search params, typically from the URL query params
 * @return {Object} Merged map of argument with current values, new values take priority
 */


function mergeSearchParamsWithCurrentCookie(paramsMap) {
  const cookie = JSON.parse(decodeURIComponent(_cookies.default.getItem(_constants.SEARCH_PARAMS_COOKIE_KEY))); // short curcuit if the current cookie value does not exist

  if (!cookie) return paramsMap; // created a merged map that defaults to current cookie values

  const mergedMap = Object.assign({}, cookie);
  Object.keys(paramsMap).forEach(key => {
    const value = paramsMap[key]; // only overide of new value is truthy,
    // dont want to override with undefineds or ''s.

    if (value) {
      mergedMap[key] = value;
    }
  });
  return mergedMap;
}